import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { debounce } from 'rxjs/operators';
import { interval } from 'rxjs';

@Component({
  selector: 'kion-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss']
})
export class QuantitySelectorComponent implements OnInit {

  @Input() formGroup: FormGroup;
  formControlName = 'quantity';

  maxValue = 99;

  // tslint:disable-next-line:no-output-rename
  @Output('changed') valueChangedEmitter: EventEmitter<number> = new EventEmitter<number>();

  @Input() actualValue = 1;

  constructor() { }

  ngOnInit(): void {
    if (this.formGroup) {
      this.formGroup.addControl(this.formControlName,  new FormControl(this.actualValue));
      this.formGroup.get(this.formControlName).patchValue(this.actualValue);
      this.formGroup.get(this.formControlName).valueChanges
        .pipe(debounce(() => interval(500)))
        .subscribe(
          value => {
            if (value < 1) {
              value = 1;
              this.formGroup.get(this.formControlName).patchValue(value);
            }
            if (value > this.maxValue) {
              value = this.maxValue;
              this.formGroup.get(this.formControlName).patchValue(value);
            }
            this.actualValue = value;
            this.valueChangedEmitter.emit(value)
          }
        )
    }
  }

  decrease() {
    const actual: number = +this.formGroup.get(this.formControlName).value;
    if (actual > 1) {
      this.formGroup.get(this.formControlName).patchValue(actual - 1)
    }
  }

  increase() {
    const actual: number = +this.formGroup.get(this.formControlName).value;
    if (actual < this.maxValue) {
      this.formGroup.get(this.formControlName).patchValue(actual + 1)
    }
  }

  changed($event: Event) {
    if ( this.formGroup.get(this.formControlName)) {
      // @ts-ignore
      this.formGroup.get(this.formControlName).patchValue($event.target.value)
    }
  }
}
